import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { browserHistory } from 'react-router';
import PartnerLicensePackageUsageRateTable from './PartnerLicensePackageUsageRateTable';
import { PartnerLicensePackageUsageRateListService } from '../../services/CustomerSuccessKpiListService';

class PartnerLicensePackageUsageRateTableContainer extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['segment', 'distributor']).isRequired,
  };

  constructor(props) {
    super(props);
    PartnerLicensePackageUsageRateListService.load();
  }

  render() {
    return (
      <PartnerLicensePackageUsageRateTable
        loading={
          PartnerLicensePackageUsageRateListService.fetchCurrent.fetching ||
          PartnerLicensePackageUsageRateListService.fetchPrevious.fetching
        }
        values={toJS(
          get(
            PartnerLicensePackageUsageRateListService,
            { segment: 'bySegment', distributor: 'byDistributor' }[this.props.type],
            []
          )
        )}
        feedbackColorRender={PartnerLicensePackageUsageRateListService.getFeedbackColor}
        onSelect={(row) => browserHistory.push(`/kpis/customer-success/${this.props.type}/${row.id}/details`)}
        formatter={PartnerLicensePackageUsageRateListService.getFormattedValue}
      />
    );
  }
}

export default observer(PartnerLicensePackageUsageRateTableContainer);
